/**
 * Mirrors api.models.ClinicalInsightValueTypes (string values must stay in sync with the API).
 */
export const ClinicalInsightValueTypes = {
  PRIMARY_VALUE: "PRIMARY_VALUE",
  INSIGHT_TIMESTAMP: "INSIGHT_TIMESTAMP",
  EXTRA: "EXTRA",
  UNKNOWN: "UNKNOWN",
} as const;

export type ClinicalInsightValueType =
  (typeof ClinicalInsightValueTypes)[keyof typeof ClinicalInsightValueTypes];
